module.exports = __webpack_public_path__ + "close.addcf8362ff7c5720f48.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/close.svg
// module id = ../../../../../src/assets/images/close.svg
// module chunks = styles